export const formatMoney = (input: number, useGrouping = true): string => {
  return (input / 100).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    useGrouping
  });
};
